var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#8cc3d5;}.b{fill:#8cc3d5;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.465)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-0.465)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 22,
    cy: 22,
    r: 21.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.208,13.035l.644-4.194H9.827V6.12a2.1,2.1,0,0,1,2.364-2.266h1.829V.283A22.31,22.31,0,0,0,10.774,0C7.46,0,5.293,2.009,5.293,5.645v3.2H1.609v4.194H5.293V23.174H9.827V13.035Z",
    transform: "translate(13.76 10.413)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cfa8bb5e.svg";
export { ForwardRef as ReactComponent };